import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { useCallback } from 'react'
import {
  EventAction,
  IMutation,
  IMutationTrackEventArgs,
  ITrackEventInput
} from 'src/types/graphql'

const TRACK_EVENT = gql`
  mutation TrackEvent($input: TrackEventInput!) {
    trackEvent(input: $input)
  }
`

const useTrackEvent = () => {
  const [trackEventMutation] = useMutation<
    Pick<IMutation, 'trackEvent'>,
    IMutationTrackEventArgs
  >(TRACK_EVENT)

  const trackEvent = useCallback(
    (input: ITrackEventInput) => {
      trackEventMutation({ variables: { input } }).catch(() => {
        // Silently fail — event tracking should never block UX
      })
    },
    [trackEventMutation]
  )

  return { trackEvent, EventAction }
}

export default useTrackEvent
